import { render, staticRenderFns } from "./ExtendOtherNutrientsNiacin.vue?vue&type=template&id=25673629&scoped=true"
import script from "./ExtendOtherNutrientsNiacin.vue?vue&type=script&lang=ts"
export * from "./ExtendOtherNutrientsNiacin.vue?vue&type=script&lang=ts"
import style0 from "./ExtendOtherNutrientsNiacin.vue?vue&type=style&index=0&id=25673629&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25673629",
  null
  
)

export default component.exports